export const FOIL_EFFECTS = 'FOIL_EFFECTS';
export const ADDITIONAL_RENDER = 'ADDITIONAL_RENDER';

export const BPC_COLOR_CODE2_RENDER = 'BPC_COLOR_CODE2_RENDER';

export const ALLOW_USER_IMAGE_COLOR = 'ALLOW_USER_IMAGE_COLOR';
